import { ByCodeResponse } from '@/app/models/projects';
import formatterMonetaryValue from '@/app/utils/numberUtils';
import DataTable, { bodyCellSx, Column } from '@/components/common/DataTable';
import TextButton from '@/components/common/TextButton';
import { TableCell, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface InitialBalanceTableProps {
  setDrawerEdit: CallableFunction;
  setSelectedHeaderItem: (id: ByCodeResponse) => void;
  data: ByCodeResponse | undefined;
}

export default function InitialBalanceTable({ setDrawerEdit, setSelectedHeaderItem, data }: InitialBalanceTableProps) {
  const theme = useTheme();

  const { t } = useTranslation(['costTracking', 'common']);

  const handleDrowersEdit = () => {
    setDrawerEdit(true);
  };

  const columns: Column[] = [
    { key: 'baseline', label: t('common:value'), width: theme.spacing(120) },
    { key: 'actions', label: t('common:actions'), align: 'center', width: theme.spacing(15) },
  ];

  const renderRow = (item: ByCodeResponse) => {
    return (
      <>
        <TableCell sx={bodyCellSx}>{formatterMonetaryValue(item.initialBalance)}</TableCell>

        <TableCell sx={{ ...bodyCellSx, textAlign: 'center' }}>
          <TextButton
            sx={{ ml: 'auto' }}
            text={`+ ${t('common:comment')}`}
            onClick={() => {
              handleDrowersEdit();
              setSelectedHeaderItem(item);
            }}
          />
        </TableCell>
      </>
    );
  };

  const getRowKey = (item: ByCodeResponse) => item.id;

  return (
    <DataTable
      columns={columns}
      data={data ? [data] : []}
      renderRow={renderRow}
      getRowKey={getRowKey}
      emptyMessage={t('common:no.data.for.the.chosen.period.and.search.term')}
      size="small"
    />
  );
}
